import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { ru } from "../translations/ru";
import { uz } from "../translations/uz";

// SSR/SSG-safe init: no LanguageDetector / localStorage. The active language is driven
// by the URL prefix (see src/routes.tsx -> LangLayout). Default + fallback = uz.
i18n.use(initReactI18next).init({
  resources: {
    uz: { translation: uz },
    ru: { translation: ru },
  },
  lng: "uz",
  fallbackLng: "uz",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
